import React, { useEffect, useRef, useState } from 'react';
import banner1 from '../images/tataAia.jpg';
import banner2 from '../images/aditya.jpg';
import banner3 from '../images/star.jpg';
import banner4 from '../images/niva.jpg';
import banner5 from '../images/care.jpg';
import banner6 from '../images/tata.jpg';
import banner7 from '../images/godigit.jpg';
import banner8 from '../images/axismax.png'
import banner9 from '../images/galaxy.png'
import banner10 from '../images/sbi.png'

const Banner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(4);
  const trackRef = useRef(null);
  const autoSlideRef = useRef(null);

  const partners = [
    {
      id: 1,
      image: banner1,
      name: 'Tata AIA Life Insurance',
      alt: 'Tata AIA Life Insurance',
      rank: '#1'
    },
    {
      id: 2,
      image: banner6,
      name: 'Tata AIG General Insurance',
      alt: 'Tata AIG General Insurance',
      rank: '#2'
    },
    {
      id: 3,
      image: banner3,
      name: 'Star Health Insurance',
      alt: 'Star Health Insurance',
      rank: '#3'
    },
    {
      id: 4,
      image: banner10,
      name: 'SBI General Insurance',
      alt: 'SBI General Insurance',
      rank: '#4'
    },
    {
      id: 5,
      image: banner4,
      name: 'Niva Bupa Health Insurance',
      alt: 'Niva Bupa Health Insurance',
      rank: '#5'
    },
    {
      id: 6,
      image: banner5,
      name: 'Care Health Insurance',
      alt: 'Care Health Insurance',
      rank: '#6'
    },
    {
      id: 7,
      image: banner7,
      name: 'GoDigit Insurance',
      alt: 'GoDigit Insurance',
      rank: '#7'
    },
    {
      id: 8,
      image: banner8,
      name: 'Axis Max Life',
      alt: 'Axis Max Life Insurance',
      rank: '#8'
    },
    {
      id: 9,
      image: banner9,
      name: 'Galaxy Health Insurance',
      alt: 'Galaxy Health Insurance',
      rank: '#9'
    },
    {
      id: 10,
      image: banner2,
      name: 'Aditya Birla Health Insurance',
      alt: 'Aditya Birla Health Insurance',
      rank: '#10'
    }
  ];

  // Update cards to show based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setCardsToShow(1);
      } else if (window.innerWidth <= 768) {
        setCardsToShow(2);
      } else if (window.innerWidth <= 1024) {
        setCardsToShow(3);
      } else {
        setCardsToShow(4);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    const startAutoSlide = () => {
      autoSlideRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const maxIndex = partners.length - cardsToShow;
          if (prevIndex >= maxIndex) {
            return 0;
          }
          return prevIndex + 1;
        });
      }, 3000); // Change slide every 3 seconds
    };

    startAutoSlide();

    return () => {
      if (autoSlideRef.current) {
        clearInterval(autoSlideRef.current);
      }
    };
  }, [cardsToShow, partners.length]);

  // Reset auto-slide timer when manually navigating
  const resetAutoSlide = () => {
    if (autoSlideRef.current) {
      clearInterval(autoSlideRef.current);
    }
    autoSlideRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = partners.length - cardsToShow;
        if (prevIndex >= maxIndex) {
          return 0;
        }
        return prevIndex + 1;
      });
    }, 3000);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex > 0) {
        return prevIndex - 1;
      }
      return prevIndex;
    });
    resetAutoSlide();
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      const maxIndex = partners.length - cardsToShow;
      if (prevIndex < maxIndex) {
        return prevIndex + 1;
      }
      return 0; // Loop back to start
    });
    resetAutoSlide();
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
    resetAutoSlide();
  };

  const maxIndex = partners.length - cardsToShow;
  const totalDots = partners.length - cardsToShow + 1;

  // Calculate translation
  const getTranslateX = () => {
    if (trackRef.current) {
      const cardWidth = trackRef.current.children[0]?.offsetWidth || 0;
      const gap = 20; // gap between cards
      return -(currentIndex * (cardWidth + gap));
    }
    return 0;
  };

  return (
    <>
      <style>
        {`
          .banner-container {
            width: 100%;
            padding: 40px 0;
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
            position: relative;
          }

          .banner-container::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: radial-gradient(circle at 10% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
            pointer-events: none;
          }

          .banner-header {
            text-align: center;
            margin-bottom: 40px;
            padding: 0 20px;
          }

          .banner-header h2 {
            font-size: 3.5rem;
            font-weight: 700;
            color: #000000;
            margin: 0;
            text-shadow: none;
            letter-spacing: -0.5px;
            line-height: 1.2;
          }

          .banner-header .subtitle {
            font-size: 1.5rem;
            color: #333333;
            margin-top: 10px;
            font-weight: 400;
          }

          /* Slider Container */
          .slider-container {
            position: relative;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 50px;
            overflow: hidden;
          }

          .slider-track {
            display: flex;
            transition: transform 0.5s ease-in-out;
            gap: 20px;
          }

          .banner-card {
            flex: 0 0 calc(25% - 15px);
            min-width: calc(25% - 15px);
            transition: transform 0.3s ease;
            position: relative;
          }

          .banner-image-wrapper {
            background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
            border-radius: 16px;
            padding: 25px 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 200px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;
            border: 1px solid rgba(255, 255, 255, 0.3);
            position: relative;
            overflow: hidden;
          }

          .banner-image-wrapper::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            transition: left 0.5s ease;
          }

          .banner-image-wrapper:hover::before {
            left: 100%;
          }

          .banner-image-wrapper:hover {
            transform: translateY(-8px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
            border-color: rgba(255, 255, 255, 0.5);
          }

          .banner-image {
            max-width: 100%;
            max-height: 140px;
            object-fit: contain;
            transition: transform 0.3s ease;
          }

          .banner-image-wrapper:hover .banner-image {
            transform: scale(1.05);
          }

          .partner-name {
            text-align: center;
            margin-top: 15px;
            font-size: 1.2rem;
            font-weight: 600;
            color: #000000;
            opacity: 0.9;
            transition: opacity 0.3s ease;
            word-wrap: break-word;
            line-height: 1.3;
          }

          .banner-card:hover .partner-name {
            opacity: 1;
            color: #1a73e8;
          }

          /* Rank Badge */
          .rank-badge {
            position: absolute;
            top: 10px;
            right: 10px;
            background: linear-gradient(135deg, #FFD700, #FFA500);
            color: #000;
            font-size: 0.85rem;
            font-weight: 700;
            padding: 5px 12px;
            border-radius: 20px;
            z-index: 2;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            transition: all 0.3s ease;
          }

          .banner-card:hover .rank-badge {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          }

          /* Navigation Buttons */
          .nav-button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background: white;
            border: 2px solid #ddd;
            cursor: pointer;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.2rem;
            color: #333;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            transition: all 0.3s ease;
            opacity: 0.8;
          }

          .nav-button:hover {
            background: #1a73e8;
            color: white;
            border-color: #1a73e8;
            opacity: 1;
            box-shadow: 0 6px 16px rgba(26, 115, 232, 0.3);
          }

          .nav-button.prev {
            left: 10px;
          }

          .nav-button.next {
            right: 10px;
          }

          .nav-button:disabled {
            opacity: 0.4;
            cursor: not-allowed;
            background: #f0f0f0;
          }

          .nav-button:disabled:hover {
            background: #f0f0f0;
            color: #333;
            border-color: #ddd;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          }

          /* Dots indicator */
          .dots-container {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 30px;
          }

          .dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #ccc;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            padding: 0;
          }

          .dot.active {
            background: #1a73e8;
            transform: scale(1.3);
          }

          /* Tablet - Show 3 images */
          @media (max-width: 1024px) {
            .banner-card {
              flex: 0 0 calc(33.33% - 14px);
              min-width: calc(33.33% - 14px);
            }

            .banner-header h2 {
              font-size: 3rem;
            }

            .banner-image-wrapper {
              height: 180px;
            }

            .partner-name {
              font-size: 0.95rem;
            }
          }

          /* Mobile - Show 2 images */
          @media (max-width: 768px) {
            .banner-container {
              padding: 30px 0;
            }

            .banner-header h2 {
              font-size: 2.5rem;
            }

            .banner-header .subtitle {
              font-size: 1rem;
            }

            .slider-container {
              padding: 0 35px;
            }

            .banner-card {
              flex: 0 0 calc(50% - 10px);
              min-width: calc(50% - 10px);
            }

            .slider-track {
              gap: 15px;
            }

            .banner-image-wrapper {
              height: 160px;
              padding: 20px 12px;
            }

            .banner-image {
              max-height: 110px;
            }

            .partner-name {
              font-size: 0.9rem;
            }

            .rank-badge {
              font-size: 0.75rem;
              padding: 4px 8px;
            }

            .nav-button {
              width: 35px;
              height: 35px;
              font-size: 1rem;
            }

            .nav-button.prev {
              left: 5px;
            }

            .nav-button.next {
              right: 5px;
            }
          }

          /* Small Mobile - Show 1 image */
          @media (max-width: 480px) {
            .banner-header h2 {
              font-size: 2rem;
            }

            .banner-card {
              flex: 0 0 100%;
              min-width: 100%;
            }

            .slider-track {
              gap: 10px;
            }

            .banner-image-wrapper {
              height: 200px;
            }

            .slider-container {
              padding: 0 30px;
            }

            .partner-name {
              font-size: 0.95rem;
            }
          }
        `}
      </style>
      
      <div className="banner-container">
        <div className="banner-header">
          <h2>Our Trusted Partners</h2>
          <div className="subtitle">Top-ranked insurance providers we work with</div>
        </div>
        
        <div className="slider-container">
          <button 
            className="nav-button prev" 
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            ❮
          </button>
          <button 
            className="nav-button next" 
            onClick={handleNext}
          >
            ❯
          </button>
          
          <div 
            className="slider-track" 
            ref={trackRef}
            style={{ transform: `translateX(${getTranslateX()}px)` }}
          >
            {partners.map((partner) => (
              <div key={partner.id} className="banner-card">
                <div className="rank-badge">{partner.rank}</div>
                <div className="banner-image-wrapper">
                  <img 
                    src={partner.image} 
                    alt={partner.alt}
                    className="banner-image"
                    title={partner.name}
                  />
                </div>
                <div className="partner-name">
                  {partner.name}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="dots-container">
          {Array.from({ length: totalDots }).map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Banner;


